import axios from 'axios'

//x获取新闻列表接口
export const getList = function (params,access_token) {
	return axios.post('/apis/biz-server/cms/list', params,{
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}
//x新闻查询接口
export const getInfoNews = function (params,access_token) {
	return axios.get('/apis/biz-server/cms/info?cmsId='+params, {
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}

//x获取新闻列表上一篇
export const beforeNext = function (params,access_token) {
	return axios.get('/apis/biz-server/cms/beforeornext?cmsId='+params+'&type=brfore', {
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}
//x获取新闻列表下一篇
export const afterNext = function (params,access_token) {
	return axios.get('/apis/biz-server/cms/beforeornext?cmsId='+params+'&type=after', {
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}


//X 查询下拉列表（字典表） 获取数据
export const getData = function (params) {
	return axios.post('/apis/biz-server/dict/list', params)
}

//X  获取视频列表接口
export const videoonlineList = function (params,access_token) {
	return axios.post('/apis/biz-server/video-online/list',params,{
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}

//x 查询视频列表接口
export const videoOnlineInfo = function (params,access_token) {
	return axios.get('/apis/biz-server/video-online/info?videoOnlineId='+params.videoOnlineId,{
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}


//x 获取学员列表接口
export const studentList = function (params,access_token) {
	return axios.post('/apis/biz-server/student/list', params,{
		headers: {
	      'Authorization':'Bearer '+access_token
	    }
	})
}


// h5 宣传页
//创建订单
export const orderAdd = function (params) {
	return axios.post('https://api.shop.yzvet.com/api/front/landingPageOrder/add', params,{
	})
}
// 查看订单详情
export const landingPageOrder = function (params) {
	return axios.get('https://api.shop.yzvet.com/api/front/landingPageOrder/detail?orderNo='+params,{
	})
}
// 抖音广告回传上报 https://analytics.oceanengine.com/api/v2/conversion
export const getConversion = function (p) {
	return axios.post('/haip-biz/oceanengine/conversion',p,{
	})
}
// export const getConversion = function (p) {
// 	return axios.post(' https://analytics.oceanengine.com/api/v2/conversion',p,{
// 	})
// }


//获取短信验证码
export const getRegisterCode = function (params) {
	return axios.post('/haip-auth-server/sms/send-identity-code', params)
  }
//短信验证码验证是否准确
export const getVerifyCode = function (params) {
	return axios.post('/haip-auth-server/sms/verify-code', params)
}

//bbs落地页提交信息
export const landingPageInsert = function (params) {
	return axios.post('/haip-biz/leads/landingPage/insert', params)
}


// 渠道管理动态获取
export const getChannelList = function(params) {
  return axios.post("/haip-activity/channel/list", params)
};
// 获取轮播图列表接口
export const portalBannerList = function (params) {
  return axios.get('/haip-biz/portalBanner/getBanner',params)
}

// 校友风采列表
export const getAlumniInformation = function (params) {
  return axios.post('/haip-activity/alumnInformation/list', params)
}
//获取校友风采详情接口
export const getAlumniInformationInfo = function (params) {
  return axios.post('/haip-activity/alumnInformation/infoNews', params)
}




// WEBPACK FOOTER //
// ./src/apis/apis.js